import { useQuery } from '@/domains/core/httpClient/queryClient';

import { useWishlistServices } from './useWishlistServices';

export const useMainListFetch = (enabled = true) => {
  const { names, calls } = useWishlistServices();

  const response = useQuery({
    queryKey: [names.getAll],
    queryFn: calls.getAll,
    notifyOnChangeProps: ['data', 'isFetched', 'isFetching'],
    enabled,
    cacheTime: 0,
  });

  const listsArePristine =
    response.data?.length === 1 &&
    response.data[0].id === 'cart' &&
    response.data[0].productCount < 1;

  return { fetchData: response, listsArePristine };
};
